exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-MypageForm-container {\n  padding: 0px !important;\n}", ""]);

// exports
